import createReducer from '../utils/createReducer';
import userInfoActions from '../actions/userInfo';

const initialState = {};

const actionHandlers = {
    [userInfoActions.GET_USER_INFO_SUCCESS](state, {payload}) {
        return {
            ...state,
            userInfoMetadata: {...payload.userInfoData}
        };
    },

    [userInfoActions.USER_INFO_SERVICE_ERROR](state, {payload}) {
        return {
            ...state,
            errorKey: payload.errorKey
        };
    }
};

export default createReducer(actionHandlers, initialState);
